// extracted by mini-css-extract-plugin
export var navRoot = "G6YhT";
export var nextPageIcon = "_2egPv";
export var nextPageLink = "e3iQO";
export var pageLink = "tDdZJ";
export var paginationItem = "wWYxi";
export var paginationList = "_6efdS";
export var previousPageIcon = "wWubY";
export var previousPageLink = "JoGzI";